import type { ApiResponse, RequestParams, RequestHeaders, ResponseType } from "@/interfaces/RequestService";
import axios from "axios";
import type { AxiosInstance } from "axios";

export const createApiClient = (): AxiosInstance => {
    const client = axios.create();

    client.defaults.headers.common.Accept = "application/json;charset=UTF-8";
    client.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
    
    return client;
};

export class RequestService {
    get = <T>(
        url: string,
        headers?: RequestHeaders,
        responseType?: ResponseType,
        params?: RequestParams,
    ): Promise<ApiResponse<T>> =>
        axios.get<T, ApiResponse<T>>(url, { params, headers, responseType });

    post = <T>(
        url: string,
        data?: unknown,
        headers?: RequestHeaders,
        responseType?: ResponseType,
        params?: RequestParams,
    ): Promise<ApiResponse<T>> =>
        axios.post<T, ApiResponse<T>>(url, data, { params, headers, responseType });

    put = <T>(
        url: string,
        data?: unknown,
        headers?: RequestHeaders,
        responseType?: ResponseType
    ): Promise<ApiResponse<T>> =>
        axios.put<T, ApiResponse<T>>(url, data, { headers, responseType });

    delete = <T>(
        url: string,
        headers?: RequestHeaders,
        responseType?: ResponseType,
        params? : RequestParams,
    ): Promise<ApiResponse<T>> =>
        axios.delete<T, ApiResponse<T>>(url, { params, headers, responseType });
}

export default new RequestService();
